import { render, staticRenderFns } from "./AssignZones.vue?vue&type=template&id=606bda70&scoped=true&"
import script from "./AssignZones.vue?vue&type=script&lang=js&"
export * from "./AssignZones.vue?vue&type=script&lang=js&"
import style0 from "./AssignZones.vue?vue&type=style&index=0&id=606bda70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606bda70",
  null
  
)

export default component.exports